module.exports = __webpack_public_path__ + "img/14.aa35802.webp";